import { useToast } from "ui-kit";
import client from "libs/client";
import { Keys } from "i18n/locales/types";
import { _ } from "i18n";

export const useUpdatePlayerStatus = () => {
    const { addSuccessToast, addErrorToast } = useToast();

    const mutation = client.updatePlayerStatus.useMutation({
        onSuccess: () => {
            addSuccessToast(_("video-tasks.modal.teamsheet.map.success.updated" as keyof Keys));

            client.queryClient.invalidateQueries({
                predicate: (query: any) => query.queryKey.includes('teamsheet'),
            });
        },
        onError: (error) => {
            addErrorToast(`Failed to update player status: ${String(error)}`);
        }
    });
    
    return { mutation };
}; 